//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    inject: ['EventBus', 'PIXIWrapper'],

    props: {
        label: {
            type: String,
            default: ''
        },
        x: {
            type: Number,
            default: 0
        },
        y: {
            type: Number,
            default: 0
        },
        width: {
            type: Number,
            default: 200
        },
        height: {
            type: Number,
            default: 60
        },
        stars: {
            type: Number,
            default: 0
        },
        bonus: {
            type: Boolean,
            default: false
        },
        arrowTopLeft: {
            type: Boolean,
            default: false
        },
        arrowTopRight: {
            type: Boolean,
            default: false
        },
        arrowBottomRight: {
            type: Boolean,
            default: false
        },
        arrowBottomLeft: {
            type: Boolean,
            default: false
        },
        arrowReverse: {
            type: Boolean,
            default: false
        }
    },

    computed: {
        hasResult () {
            return this.$store.getters.hasUserResult(this.$route.meta.week, this.$route.meta.day, this.$route.meta.game);
        },
        labelBubble () {
            if (this.bonus) {
                return this.$lang.get('partials.bubble.bravo', {br: '\n', stars: this.stars});
            }

            if (this.stars === 0) {
                return this.$lang.get('partials.bubble.none');
            }

            if (this.label !== '') {
                return `${this.label}\n+${this.stars}`;
            }

            if (this.stars === 1) {
                return this.$lang.get('partials.bubble.one', {br: '\n', stars: this.stars});
            }

            return this.$lang.get('partials.bubble.several', {br: '\n', stars: this.stars});
        },
        bubbleX () {
            if (this.arrowBottomRight || this.arrowTopRight) {
                return this.bonus ? this.x - 25 : this.x;
            }

            return this.bonus ? this.x + 25 : this.x;
        },
        bubbleY () {
            if (this.arrowTopLeft || this.arrowTopRight) {
                return this.bonus ? this.y + 10 : this.y;
            }

            return this.bonus ? this.y - 10 : this.y;
        },
        starX () {
            if (this.arrowBottomRight || this.arrowTopRight) {
                return this.bonus ? this.x - 10 : this.x + 15;
            }

            return this.bonus ? this.x + 40 : this.x + 15;
        },
        starY () {
            if (this.arrowTopLeft || this.arrowTopRight) {
                return this.bonus ? this.y + 17 : this.y - 3;
            }

            return this.bonus ? this.y : this.y - 3;
        }
    }
};
